module.exports = __webpack_public_path__ + "static/media/casa-wifi.37117dea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/contentassets/casa-wifi.svg
// module id = 161
// module chunks = 0